import { render } from "./FaqAuth.vue?vue&type=template&id=2086bb3c"
import script from "./FaqAuth.vue?vue&type=script&lang=js"
export * from "./FaqAuth.vue?vue&type=script&lang=js"
script.render = render

export default script